export const WILDCARD = 'Any';
export type WildcardType = typeof WILDCARD;
